import { Component, OnInit } from '@angular/core';
import {  Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { MyTicketsComponent } from 'src/app/shared/cinejoy/common/my-tickets/my-tickets.component';

@Component({
  selector: 'app-movie-page-side-bar',
  templateUrl: './movie-page-side-bar.component.html',
  styleUrls: ['./movie-page-side-bar.component.css']
})
export class MoviePageSideBarComponent implements OnInit {
    searchIcon: any = 'assets/images/cinejoy/Search.png';
    hideSidebar:boolean=true; 
  constructor(private modalService: NgbModal, public router: Router,private service: ShowcaseService ) {}
    
    ngOnInit(): void {}
    closeSideBar(){
      this.hideSidebar=!this.hideSidebar;
    }
    openMyTicket(): void {
      const modalRef = this.modalService.open(MyTicketsComponent, { size: 'lg', backdrop: 'static' });
    } 
  }
  
